import React, {useEffect, useState} from 'react';
import {Badge, Button, message, Modal} from 'antd';
import {useApi} from "./ApiProvider";
import {useNavigate} from "react-router-dom";

interface NewCasePageProps {
    createNewChat: (workflow: string, exampleCase: boolean) => void
}

export default function NewCasePage(props: NewCasePageProps) {

    const api = useApi();
    const [workflows, setWorkflows] = useState<{ [p: string]: { description: string, exampleCase: string, pricePerRun?: number } }>({});
    const navigate = useNavigate();
    const [limitErrorModal, setLimitErrorModal] = useState<{ visible: boolean, title?: string, content?: string }>({
        visible: false,
    });

    const handleTopUp = async (amount: number) => {
        try {
            await api.payAmountForUser({amount: amount}).then(res => window.location.href = `${res.data}`);
        } catch (error) {
            console.error("Failed to top up balance:", error);
        }
    };

    const showLimitError = (content: string) => {
        setLimitErrorModal({
            visible: true,
            title: "Insufficient Balance",
            content: content,
        });
    };


    useEffect(() => {

        async function fetchWorkflows() {
            try {
                const response = await api.allWorkflowsWithDescription();
                const data = response.data;
                setWorkflows(data);
            } catch (error) {
                console.error('Error fetching workflows:', error);
            }
        }

        fetchWorkflows().then();
    }, []);
    const getAppFileName = () => {
        return '/' + process.env.REACT_APP_LOGO_FILE_NAME
    }

    return (

        <div className="new-case-page-container">
            <div style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center'
            }}>
                <img src={getAppFileName()} alt="Company Logo" className="new-case-page-company-logo"/>
            </div>
            <Modal
                title={<span><span style={{ color: '#faad14', marginRight: 8 }}>⚡</span> Not Enough Credits</span>}
                open={limitErrorModal.visible}
                onCancel={() => setLimitErrorModal({ visible: false })}
                footer={[
                    <Button key="topup-5" type="primary" onClick={() => handleTopUp(5)}>
                        Add $5
                    </Button>,
                    <Button key="topup-10" type="primary" onClick={() => handleTopUp(10)}>
                        Add $10
                    </Button>,
                    <Button key="topup-15" type="primary" onClick={() => handleTopUp(15)}>
                        Add $15
                    </Button>,
                ]}
            >
                <p style={{ fontSize: 16 }}>
                    {limitErrorModal.content || "You need more credits to start this workflow. Please top up your account to continue."}
                </p>
                <p style={{ color: 'rgba(0,0,0,0.45)' }}>
                    After top up, you will be redirected to the payment page.
                </p>
            </Modal>
            <div>
                <div className="new-case-page-buttons-group">
                    {Object.entries(workflows).map(([key, value]) => {
                        const content = (
                            <div key={key} style={{
                                display: 'flex', height: '100%', paddingBottom: '10px'
                            }}>
                                <Button
                                    className="new-case-page-custom-button"
                                    onClick={() => {
                                        api.checkMoneyAndTokenLimit(key).then( res => {
                                            navigate('/run/' + key)
                                        }).catch(err => {
                                            if (err?.response?.status == 402) {
                                                console.log(err)
                                                showLimitError(err?.response?.data || "You don't have enough credits or you reached your limit.");
                                            }
                                            else message.error(err?.response?.message).then(r => {})
                                        })
                                    }}
                                    style={{display: 'flex', justifyContent: 'space-between', width: '100%',}}
                                >
                                    <div style={{flex: 1}}>
                                        <span className="new-case-page-bold-text">{key}</span>
                                        <br/>
                                        <span className="new-case-page-light-text">{value.description}</span>
                                    </div>
                                    {value.exampleCase && (
                                        <div>
                                            <Button
                                                style={{marginTop: 5}}
                                                onClick={(event) => {
                                                    api.checkMoneyAndTokenLimit(key).then( res => {
                                                        navigate('/run/' + key + '?exampleCase=true')
                                                    }).catch(err => {
                                                        if (err?.response?.status == 402) {
                                                            console.log(err)
                                                            showLimitError(err?.response?.data || "You don't have enough credits or you reached your limit.");
                                                        }
                                                        else message.error(err?.response?.message).then(r => {})
                                                    })
                                                    event.stopPropagation();
                                                }}
                                            >
                                                Example Case
                                            </Button>
                                        </div>
                                    )}
                                </Button>
                            </div>
                        );

                        return <Badge.Ribbon key={key} style={{right: -2}}
                                             text={value.pricePerRun ? + value.pricePerRun + " credit" : "free"}
                                             color={value.pricePerRun ? "orange" : "blue"}>
                            {content}
                        </Badge.Ribbon>
                        // return content
                    })}
                </div>
            </div>
            <div style={{
                color: 'grey',
                opacity: 0.9,
                fontSize: 'small',
                textAlign: 'center',
                paddingBottom: 15,
                paddingTop: 15
            }}>
                Information is provided for informational purposes only and should not replace professional judgment.
            </div>
        </div>
    );
};
